import { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Popover, PopoverProps } from '@servicetitan/design-system';
import { DelayedPopoverStore } from '../stores/delayed-popover.store';

export interface DelayedPopoverProps extends PopoverProps {
    /** 100 by default */
    mouseLeaveDelay?: number;
    autoOpen?: boolean;
    autoOpenDelay?: number;
    autoOpenTime?: number;
    doNotCloseOnClickOutSide?: boolean;
}

// temporary location. Need to decide later the package in anvil-uikit-contrib
export const DelayedPopover: FC<DelayedPopoverProps> = provide({
    singletons: [DelayedPopoverStore],
})(
    observer<FC<DelayedPopoverProps>>(
        ({
            mouseLeaveDelay,
            autoOpen,
            autoOpenDelay,
            autoOpenTime,
            doNotCloseOnClickOutSide,
            ...rest
        }) => {
            const [store] = useDependencies(DelayedPopoverStore);

            const handleMouseEnter = () => {
                store.open();
            };

            const handleMouseLeave = () => {
                store.close(mouseLeaveDelay);
            };

            const handleClickOutside = () => {
                if (!doNotCloseOnClickOutSide) {
                    store.close(0);
                }
            };

            useEffect(() => {
                if (!store.isOpen && autoOpen) {
                    store.autoOpen(autoOpenTime, autoOpenDelay);
                }
            }, [autoOpen, autoOpenDelay, autoOpenTime, store]);

            return (
                <Popover
                    {...rest}
                    open={store.isOpen}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClickOutside={handleClickOutside}
                >
                    {rest.children}
                </Popover>
            );
        }
    )
);
